import styled from 'styled-components';

export const LanguagePickerContainerStyled = styled.div<{ mobile?: boolean }>`
	gap: 8px;
	display: flex;
	align-items: center;
	padding: ${props => (props.mobile ? `16px 0;` : `0`)};
	cursor: pointer;
`;

export const LanguageDividerStyled = styled.div`
	width: 1px;
	height: 15px;
	background-color: #8c8c8c;
`;

export const LanguageOptionStyled = styled.p<{ active: boolean }>`
	margin: 0;
	color: ${props => (props.active ? `#000` : `#8c8c8c`)};
	font-weight: 400;
	font-size: 14px;
`;
